import OperatorList from "../../Components/OperatorManagement/OperatorManagementListing";

export default function OperatorListing(){
    return(
        <OperatorList/>
    )
}